import React, { useEffect, useRef } from 'react';

interface AdDesignMidProps {
  className?: string;
}

const AdDesignMid: React.FC<AdDesignMidProps> = ({ className }) => {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const isScriptInjected = useRef(false);

  useEffect(() => {
    if (isScriptInjected.current || !adContainerRef.current) return;
    
    // Create and inject the script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.diclotrans.com/sdk/v1/51389/4f5342a1202da84a4c528c988d098c3c20b7f936/lib.js';
    script.async = true;
    
    // Append the script to the container
    adContainerRef.current.appendChild(script);
    
    isScriptInjected.current = true;
    
    // Cleanup function
    return () => {
      if (adContainerRef.current) {
        const scriptElement = adContainerRef.current.querySelector('script[src="https://cdn.diclotrans.com/sdk/v1/51389/4f5342a1202da84a4c528c988d098c3c20b7f936/lib.js"]');
        if (scriptElement) {
          adContainerRef.current.removeChild(scriptElement);
        }
      }
      isScriptInjected.current = false;
    };
  }, []);

  return (
    <div className={`mx-auto ${className || ''}`} style={{ display: 'flex', justifyContent: 'center' }}>
      <div 
        ref={adContainerRef} 
        className="ad-design-mid"
        style={{ 
          height: '250px', 
          width: '300px', 
          overflow: 'hidden',
          display: 'block',
          minWidth: '300px',
          minHeight: '250px'
        }}
      />
    </div>
  );
};

export default AdDesignMid;